import { Injectable, Inject, PLATFORM_ID  } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BehaviorSubject } from 'rxjs';
import { isPlatformBrowser } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class FileUploadService {
  private headerSource = new BehaviorSubject<string>('Default Header');
  private subHeaderSource = new BehaviorSubject<string>('Default Sub-header');
  private buttonNameSource = new BehaviorSubject<string>('Default Button Name');
  private cheaderSource = new BehaviorSubject<string>('Default Sub-header');
  private cbuttonNameSource = new BehaviorSubject<string>('Default Button Name');
  private fileTypeSource = new BehaviorSubject<string>('Default File Type');
  private htmltoImage = new BehaviorSubject<string>('Default Request');
  private htmltoPdf = new BehaviorSubject<string>('Default Request');
  private downloadHeaders = new BehaviorSubject<string>('Default Request');
  private downloadButton = new BehaviorSubject<string>('Default Request');
  private iconIdentifierRequest = new BehaviorSubject<string>('Default Request');
  private downloadFileType = new BehaviorSubject<string>('Default Request');
  private subSubHeaderSource = new BehaviorSubject<string>('Default Request');
  private numberofPdfPages = new BehaviorSubject<number>(0);
  private ErrorMessageSource = new BehaviorSubject<boolean>(false);
  private isBrowser: boolean;


  constructor(private http: HttpClient,@Inject(PLATFORM_ID) platformId: object) {this.isBrowser = isPlatformBrowser(platformId);}

  currentHeader = this.headerSource.asObservable();
  currentSubHeader = this.subHeaderSource.asObservable();
  currentButtonName = this.buttonNameSource.asObservable();
  ccurrentHeader = this.cheaderSource.asObservable();
  ccurrentButtonName = this.cbuttonNameSource.asObservable();
  currentFileType = this.fileTypeSource.asObservable();
  currentHtmltoImage = this.htmltoImage.asObservable();
  currentHtmltoPdf = this.htmltoPdf.asObservable();
  currentDownloadHeaders = this.downloadHeaders.asObservable();
  currentDownloadButton= this.downloadButton.asObservable();
  currenticonIdentifierRequest= this.iconIdentifierRequest.asObservable();
  currentDownloadFileType= this.downloadFileType.asObservable();
  currentsubSubHeader= this.subSubHeaderSource.asObservable();
  currentnumberofPdfPages= this.numberofPdfPages.asObservable();
  currentErrorMessage= this.ErrorMessageSource.asObservable();

  changeErrorMessage(errorMessage: boolean) {
    this.ErrorMessageSource.next(errorMessage);
  }
  changeHeader(header: string) {
    this.headerSource.next(header);
  }

  changeSubHeader(subHeader: string) {
    this.subHeaderSource.next(subHeader);
  }

  changeButtonName(buttonName: string) {
    this.buttonNameSource.next(buttonName);
  }
  cchangeHeader(header: string) {
    this.cheaderSource.next(header);
  }
  cchangeButtonName(buttonName: string) {
    this.cbuttonNameSource.next(buttonName);
  }

  changeFileType(fileType: string) {
    this.fileTypeSource.next(fileType);
  }
  changeHtmltoPdfRequest(fileType: string) {
    this.htmltoPdf.next(fileType);
  }
  changeHtmltoImageRequest(fileType: string) {
    this.htmltoImage.next(fileType);
  }
  changeDownloadheaderRequest(fileType: string) {
    this.downloadHeaders.next(fileType);
  }
  changeDownloadButtonRequest(fileType: string) {
    this.downloadButton.next(fileType);
  }
  changeiconIdentifierRequest(fileType: string) {
    this.iconIdentifierRequest.next(fileType);
  }
  changeDownloadFileType(fileType: string) {
    this.downloadFileType.next(fileType);
  }
  changeSubSubHeader(fileType: string) {
    this.subSubHeaderSource.next(fileType);
  }
  changenumberofPdfPages(fileType: number) {
    this.numberofPdfPages.next(fileType);
  }
  uploadFile(endpointUrl: string, file: File): Observable<Blob> {
    const formData = new FormData();
    formData.append('file', file);
    return this.http.post(endpointUrl, formData, { responseType: 'blob' });
  }
}
